import { useMemo } from 'react';
import { Folder } from '../../../types';
import { getFolderPathById } from '../../FoldersList/FoldersList.utils';

export const FOLDER_DEPTH_LIMIT = 7;
export const PARENT_FOLDER_DEPTH_LIMIT = FOLDER_DEPTH_LIMIT - 1;

export const useIsUnderDepthLimit = ({
  checkDepthLimit,
  selectedFolderId,
  folders
}: {
  checkDepthLimit: boolean;
  selectedFolderId: Folder['id'];
  folders: Folder[];
}) => {
  return useMemo(() => {
    const folderPath = selectedFolderId ? getFolderPathById({ folders, folderId: selectedFolderId }) : [];
    const isUnderFolderDepthLimit = !folderPath || folderPath.length < FOLDER_DEPTH_LIMIT;

    if (!checkDepthLimit) {
      return {
        isUnderParentFolderDepthLimit: true,
        isUnderFolderDepthLimit
      };
    }
    return {
      isUnderParentFolderDepthLimit: !folderPath || folderPath.length < PARENT_FOLDER_DEPTH_LIMIT,
      isUnderFolderDepthLimit
    };
  }, [checkDepthLimit, selectedFolderId, folders]);
};
